import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';
import { connect } from 'react-redux';
import Section from '../../Section';
import SectionList from '../../SectionList';
import { AgencyCard } from '../../Cards/AgencyCard';
import { SectionPlaceholder } from '../../Placeholders/SectionPlaceholder';
import AgencyCardPlaceholder from '../../Placeholders/AgencyCardPlaceholder';
import { agenciesQuery } from '../../../queries';
import { setError } from '../../../actions';

const mapDispatchToProps = dispatch => {
  return {
    setErrorUI: errorState => dispatch(setError(errorState))
  };
};

const AgenciesList = ({ setErrorUI }) => {
  const { t } = useTranslation();
  const { loading, data, error } = useQuery(agenciesQuery, {
    ssr: false,
    fetchPolicy: 'network-only'
  });
  const placeholder = (
    <SectionPlaceholder column={true} more={false}>
      <AgencyCardPlaceholder />
      <AgencyCardPlaceholder />
      <AgencyCardPlaceholder />
      <AgencyCardPlaceholder />
      <AgencyCardPlaceholder />
    </SectionPlaceholder>
  );
  const agencies = data?.agencies || [];
  const agenciesList =
    agencies && agencies.map(item => <AgencyCard key={item.id} {...item} />);

  useEffect(() => {
    if (error) setErrorUI(true);
  }, [error]);

  if (loading) return placeholder;

  return (
    <Section
      sectionAdditionalClasses="section-page"
      title={t('pages.agencies.title')}
      cypress="agencies-page-title"
    >
      <SectionList>{agenciesList}</SectionList>
    </Section>
  );
};

AgenciesList.propTypes = {
  setErrorUI: PropTypes.func
};

export default connect(null, mapDispatchToProps)(AgenciesList);
